import React, { useEffect, useState } from "react";
import Header from "../Header/Header";
import "./Home.css";
import people from "../../assets/people.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown,faXmark} from "@fortawesome/free-solid-svg-icons";
import { faHeart } from "@fortawesome/free-solid-svg-icons";
import bg from '../../assets/bg.jpg'
import jobPic from "../../assets/jobBG.jpg";
import religiousPic from '../../assets/religiousBG.jpg'
import charityPic from '../../assets/charityBG.jpg'
import sportsPic from '../../assets/sportsBG.jpg'
import musicPic from '../../assets/musicBG.jpg'
import logo from '../../assets/logo.png';
import axios from "axios";
import { useNavigate } from "react-router-dom";
import LoadingScreen from "../../LoadingScreen";

const Home = () => {

const [upcomingEvents, setUpcomingEvents] = useState([]);
const [eventsToShow, setEventsToShow] = useState(4);
const [selectedCity, setSelectedCity] = useState("");
const [selectedCountry, setSelectedCountry] = useState("");
const [hasMoreEvents, setHasMoreEvents] = useState(true);
const [countryName,setCountryName] = useState();
const [cities, setCities] = useState([]);
const [selectedEventType,setSelectedEventType] = useState();
const [title,setTitle] = useState();
const [date,setDate] = useState();
const [loading,setLoading] = useState(true);
const [suggestionOn,setSuggestionOn] = useState(false);
const eventType = ['Music','Sports','Job Event','Charity Event','Religious Event'] 


const navigate = useNavigate();

const countryData = {
  "Select Country": "",
  "United States": "US",
  "United Kingdom": "GB",
  "Canada": "CA",
  "France": "FR",
  "Italy": "IT",
  "Spain": "ES",
  "India": "IN"
};


  useEffect(() => {
    if (selectedCountry) {
      fetchCities(selectedCountry);
    }
  }, [selectedCountry]);


  const fetchCities = async (country) => {
    try {
      const username = "smi11";
      const response = await axios.get(
        `http://api.geonames.org/searchJSON?country=${country}&maxRows=25&username=${username}`
      );

      const citiesData = response.data.geonames.map((city) => city.name);
      const filteredCities = citiesData.filter((city) => city !== countryName);
      setCities(filteredCities);
      console.log(citiesData)
    } catch (error) {
      console.log("Error fetching cities:", error);
    }
  };

  const handleCityChange = (e) => {
    setSelectedCity(e.target.value);
  };


  const handleCountryChange = async (e) => {
    const selectedCountryCode = e.target.value;
    const selectedCountryName = Object.keys(countryData).find(key => countryData[key] === selectedCountryCode);
    setSelectedCountry(selectedCountryCode);
    setCountryName(selectedCountryName);
    setCities([]); 
  
    await getUpcomingEvents(selectedCountryCode, selectedCountryName, selectedCity, selectedEventType, date, title);
  };



  useEffect(() => {
    getUpcomingEvents(selectedCountry, countryName, selectedCity, selectedEventType, date, title);
    setLoading(false);
  }, [selectedEventType, selectedCountry, selectedCity, date, title]);





  const getUpcomingEvents = async (countryCode, countryName, city, eventType, eventDate, eventTitle) => {
    try {

      var key = Object.keys(countryData).find(key => countryData[key] === countryCode);

      if(key === 'Select Country')
        key = "";

      const params = {
        term: eventTitle,
        date: eventDate,
        country: key,
        city: city,
        tag: eventType
      }
  
      console.log(params)
  
      const events = await axios.get("https://event-finder12.onrender.com/events/search",{params});
      setUpcomingEvents(events.data);
      console.log(events.data)

  
      if (events.data.length <= eventsToShow) {
        setHasMoreEvents(false);
      } else {
        setHasMoreEvents(true)
      }
    } catch (err) {
      console.log(err);
    }
  };


  const handleLoadMore = () => {
    setEventsToShow((prevCount) => prevCount + 4);
  };


  const handleEventChange = (e) => {
    setSelectedEventType(e.target.value);
  }

  const handleChangeTitle = (e) => {
    setTitle(e.target.value)
    setSuggestionOn(true);
  }

  const handleChangeDate = (e) => {
    setDate(e.target.value);
  }

  const handleClearFilter = () => {
    setSelectedEventType("");
    setSelectedCountry("");
    setSelectedCity("");
    setDate("");
    setTitle("");
  }


  const navigateToEvent = (id) => {
    navigate(`/event/${id}`);
  }

  const handleSelectedSuggestion = (e) => {
    setTitle(e);
    setSuggestionOn(false);
  }



  return (
    <div className="outer-container">
          {loading ? <LoadingScreen/> : (<>
            <div className="head-banner">
        <Header className="header" />
        <div className="head-middle-row">
          <img src={people} className="people-img" />
          <div className="head-middle-info">
            <h1>
              Discover Exciting Events Near You: Your Ultimate Event Finder
            </h1>
            <h3>
              "Explore a World of Entertainment and Activities: Your Go-To
              Source for Local and Virtual Events"
            </h3>
          </div>
        </div>
      </div>
      <div className="head-search-container">
        <div className="head-search">
          <div className="head-search-event">
            <p>Search Event</p>
            <input onChange={(e)=>handleChangeTitle(e)} value={title} placeholder="Search.." type="text" />
            <ul className={suggestionOn && title.length ? "display-suggestion" : "hidden-suggestion"}>
        {upcomingEvents?.slice(0,3).map((event, index) => (
          <li key={index} onClick={() => handleSelectedSuggestion(event.title)}>
            {title?.length ? event.title : ""}
          </li>
        ))}
      </ul>
          </div>
          <div className="head-search-event">
            <p>Country</p>
            <select className="country-select" value={selectedCountry} onChange={handleCountryChange}>
              {Object.keys(countryData).map((country) => (
                <option key={countryData[country]} value={countryData[country]}>
                  {country}
                </option>
              ))}
            </select>
          </div>
          <div className="head-search-event">
            <p>Date</p>
            <input onChange={(e)=>handleChangeDate(e)} placeholder="&nbsp;" type="date" />
          </div>
        </div>
      </div>

      <div className="event-container">
        <div className="event-head">
          <h2>Upcoming Events</h2>
          <div className="event-button-container">
            {/* <div className="event-button">City <FontAwesomeIcon icon={faChevronDown} /></div> */}
            <select className="event-button" value={selectedCity} onChange={handleCityChange}>
              <option value="">Select City</option>
              {cities.map((city) => (
                <option key={city} value={city}>
                  {city}
                </option>
              ))}
            </select>
            <select className="event-button" value={selectedEventType} onChange={handleEventChange}>
              <option value="">Select Event Type</option>
              {eventType.map((event) => (
                <option key={event} value={event}>
                  {event}
                </option>
              ))}
            </select>
            {selectedEventType || selectedCountry || selectedCity || date || title ? <div onClick={handleClearFilter} className="event-button">Clear Filter <FontAwesomeIcon icon={faXmark} style={{color: "#da2f49",}} /></div> : <></>}
            {/* <div className="event-button">Any Category <FontAwesomeIcon icon={faChevronDown} /></div> */}
          </div>
        </div>

        <div className="event-cards">
        {upcomingEvents.length!==0 ? upcomingEvents.slice(0, eventsToShow).map((event, index) => (
          <div onClick={()=>navigateToEvent(event._id)} className="event-card" key={event._id}>
            <img src={event.tag==='Music'? musicPic : event.tag==='Charity Event' ? charityPic : event.tag==='Job Event' ? jobPic : event.tag==='Sports' ? sportsPic : event.tag==='Religious Event' ? religiousPic : null} />
            <div className="event-card-details">
              <div className="event-card-details-date">
                <h3>{new Date(event.date).toLocaleString("default", { month: "short" })}</h3>
                <h2>{new Date(event.date).getDate()}</h2>
              </div>
              <div className="event-card-details-info">
                <h3>{event.title}</h3>
                <h4>{event.description}</h4>
              </div>
            </div>
          </div>
        )):<><div>NO EVENTS</div></>}
      </div>

      {hasMoreEvents && hasMoreEvents && (
        <div className="load-container">
          <div className="load-button" onClick={handleLoadMore}>
            Load More
          </div>
        </div>
      )}

      {!hasMoreEvents && upcomingEvents.length > 0 && (
        <div className="no-more-events"></div>
      )}
    
      </div>

      <div className="footer"> 
            <div className="footer-info">
                <img src={logo}/>
                <h3>Discover upcoming events in your town: Your go-to online destination for staying updated with the latest happenings.</h3>
            </div>
            <hr className="line"/>
           <h4 className="copyright">Made with <FontAwesomeIcon style={{color:"red"}} icon={faHeart} /> by Sekh Mohammad Irfan </h4>
      </div>
      </>)}
    
    </div>
  );
};

export default Home;
